import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { RsbService } from 'src/app/service/rsb.service';

@Component({
  selector: 'app-vendor-dashboard',
  templateUrl: './vendor-dashboard.component.html',
  styleUrls: ['./vendor-dashboard.component.css']
})
export class VendorDashboardComponent implements OnInit {
  getMylead: any[] = [
    {
      listingId: 'PB-1001',
      propertyTitle: '3 BHK Apartment at Pillar Heights',
      customerName: 'Amit Sharma',
      cmobile: '9876543210',
      cemail: 'amit.sharma@example.com'
    },
    {
      listingId: 'PB-1002',
      propertyTitle: 'Commercial Space at Grand Avenue',
      customerName: 'Neha Verma',
      cmobile: '9812345678',
      cemail: 'neha.verma@example.com'
    },
    {
      listingId: 'PB-1003',
      propertyTitle: 'Villa at Lakeview Residency',
      customerName: 'Rahul Mehta',
      cmobile: '9898765432',
      cemail: 'rahul.mehta@example.com'
    }
  ];

  dashboardStats = {
    saleProperties: 24,
    rentProperties: 12,
    projects: 8,
    totalLeads: 36,
    commercialProperties: 6,
    loansPassed: 14
  };

  projects = [
    {
      name: 'Pillar Heights',
      location: 'Noida Extension',
      properties: 48,
      status: 'Active'
    },
    {
      name: 'The Grand Avenue',
      location: 'Greater Noida',
      properties: 32,
      status: 'Active'
    },
    {
      name: 'Lakeview Residency',
      location: 'Ghaziabad',
      properties: 25,
      status: 'Coming Soon'
    }
  ];

  constructor(
    private rsbService:RsbService,
    private rsbLookup:RsbLookupModel,
    private route:Router) { }
  Postproperty(route:any){
    this.route.navigate([route]);
  }
  Applyloan(route:any){
    this.route.navigate([route]);
  }

  ngOnInit(): void {
  }
  getMyleads() {
    this.rsbService.myLeads().subscribe((rsp) => {
      this.getMylead = rsp.contents;


    })

  }

}
